import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import {
    get_headers,
    GET_ALL_PACKAGES,
    CREATE_PACKAGE_SERVICE,
    UPDATE_SERVICE_PACKAGE,
    GET_ALL_PROJECT_SERVICES,
    ASSIGN_SERVICES_TO_PACKAGE,
    SERVICES_IN_PACKAGE,
} from '@/utils/constants/constants.js';
import axios from 'axios';
import $ from 'jquery';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import alert_mixin from '@/utils/mixins/alert_mixin';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import { validate_non_empty_string } from '@/utils/validations/validate_inputs';
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";

export default {
    name: 'PackageServiceManagement',
    mixins: [alert_mixin, formatting_mixins],
    components: {
    NavigationBackButton,
    },
    data: () => ({
        headers: get_headers(),
        project_id: sessionStorage.getItem('project_id'),
        current_package: {
            id: null,
            package_name: '',
            package_description: '',
            price: ''
        },
        package_data: [],
        table_safe_form_list: [],
        form_table_headers: [],
        table_safe_services_list: [],
        services_table_headers: [],
        selected_project_id: '',
        projects: [],   
    }),

    methods: {
        open_create_modal() {
            this.current_package = {
                id: null,
                package_name: '',
                package_description: '',
                price: ''
            };
        },

        open_edit_modal(service) {
            this.current_package = {
                id: service.id,
                package_name: service.name,
                package_description: service.description,
                price: service.price
            };
        },

        destroy_data_table() {
            if (this.dataTable) {
                this.dataTable.destroy();
                this.dataTable = null;
            }
        },

        async assign_services_modal(service) {
            this.current_package = {
                id: service.id,
                package_name: service.name,
                package_description: service.description,
                price: service.price
            };

            try {
                await this.get_services();
                await this.get_services_with_assignment(service.id);

                this.$nextTick(() => {
                    $('#assign_services').off('shown.bs.modal').on('shown.bs.modal', () => {
                    this.initialize_services_data_table();
                    });
                });
            }  catch (error) {
                const message = error.response?.data?.message || error.message;
                this.show_error("Failed to open assign modal: " + message);
            }


        },





        get_package_services() {
            this.destroy_data_table();
            this.package_data = [];

            axios.get(GET_ALL_PACKAGES, {
                headers: this.headers,
            })
            .then(response => {
                const parsed_response = response.data;
                if (parsed_response.data && parsed_response.data.length > 0) {
                    this.package_data = parsed_response.data;
                    this.transform_forms_data();
                } else {
                    this.forms = [];
                }
            })
            .catch(error => {
                this.show_error('Error getting packages: ' + (error.response?.data?.message || error.message));
                this.package_data = [];
            });
        },

        async get_services() {
            this.destroy_data_table();
            this.services_data = [];

            const query_params = {
                project_id: this.project_id,
            };

            try {
                const response = await axios.get(GET_ALL_PROJECT_SERVICES, {
                    headers: this.headers,
                    params: query_params,
                });

                const parsed_response = response.data;
                if (parsed_response.data && parsed_response.data.length > 0) {
                    this.services_data = parsed_response.data;
                    this.transform_services_data();
                } else {
                    this.table_safe_services_list = [];
                }
            } catch (error) {
                this.show_error('Error getting packages: ' + (error.response?.data?.message || error.message));
                this.services_data = [];
            }
        },

        transform_services_data() {
            if (this.services_data.length > 0) {
                const TABLE_FORM_DATA = this.services_data.map(service => ({
                    id: service.id,
                    name: service.name,
                    description: service.description,
                    price: service.price,
                }));

                this.services_table_headers = Object.keys(TABLE_FORM_DATA[0]);
                this.table_safe_services_list = TABLE_FORM_DATA;
            } else {
                this.services_table_headers = [];
            }

            this.$nextTick(() => {
                this.initialize_services_data_table();
            });
        },





        transform_forms_data() {
            if (this.package_data.length > 0) {
                const TABLE_FORM_DATA = this.package_data.map(form => ({
                    id: form.id,
                    name: form.name || form.form_name,
                    description: form.description || form.form_description,
                    price: form.base_price,
                    date_created: this.format_date(form.date_created)
                }));

                this.form_table_headers = Object.keys(TABLE_FORM_DATA[0]);
                this.table_safe_form_list = TABLE_FORM_DATA;
            } else {
                this.table_safe_form_list = [];
            }

            this.$nextTick(() => {
                this.initialize_data_table();
            });
        },

        
        initialize_services_data_table() {
            this.$nextTick(() => {
                const table_id = '#services_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }
                
                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },


        initialize_data_table() {
            this.$nextTick(() => {
                const table_id = '#forms_table';
                const table = $(table_id);

                if (table.length === 0) {
                    return;
                }
                if ($.fn.DataTable.isDataTable(table)) {
                    table.DataTable().clear().destroy();
                }
                
                this.dataTable = table.DataTable({
                    responsive: true,
                    autoWidth: false,
                    pageLength: 10
                });
            });
        },

        
        async create_package_service() {
            if (!validate_non_empty_string(this.current_package.package_name)) {
                this.show_error('Package name is required.');
                return;
            }
        
            if (this.current_package.package_description !== '') {
                if (!validate_non_empty_string(this.current_package.package_description)) {
                    this.show_error('Package description is required.');
                    return;
                }
            }

            const payload = {
                name: this.current_package.package_name,
                description: this.current_package.package_description,
                base_price: this.current_package.price
            };

            
            axios.post(CREATE_PACKAGE_SERVICE, payload, { headers: this.headers })
                .then(response => {
                    const response_data = response.data;

                
                    const { status, message } = response_data;
                    if (status === 'success') {
                        this.close_modal('create_package_service');
                        this.show_success('Package created successfully.');
                        window.location.reload();
                    } else {
                        this.show_error('Error creating package: ' + (message || 'Unknown error'));
                        this.close_modal('create_form');
                    }
                })
                .catch(error => {
                    this.show_error('Error creating package: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                    this.close_modal('create_package_service');
                });
        },

        async update_service() {
   
            const payload = {
                package_id: this.current_package.id,
                name: this.current_package.package_name,
                description: this.current_package.package_description,
                base_price: this.current_package.price
            };

            
            axios.post(UPDATE_SERVICE_PACKAGE, payload, { headers: this.headers })
                .then(response => {
                    const response_data = response.data;
                    const { status, message } = response_data;


                    if (status && status.trim().toLowerCase() === 'success') {
                        this.close_modal('edit_package_service');
                        this.get_package_services();
                        this.show_success('Package updated successfully.');
                    } else {
                        this.show_error('Error updating package: ' + (message || 'Unknown error'));
                        this.close_modal('edit_service');
                    }
                })
                .catch(error => {
                    this.show_error('Error updating package: ' + (error.response?.data?.message || 'An unexpected error occurred'));
                    this.close_modal('edit_package_service');
                });

        },


        async save_assignment() {
            const selected_services = this.table_safe_services_list
                .filter(service => service.selected)
                .map(service => service.id);

            const payload = {
                package_id: this.current_package.id,
                service_ids: selected_services
            };

            try {
                const response = await axios.post(ASSIGN_SERVICES_TO_PACKAGE, payload, {
                    headers: this.headers
                });

                const { status, message } = response.data;

                if (status === "success") {
                    if (selected_services.length === 0) {
                        this.show_success("All services have been unassigned.");
                    } else {
                        this.show_success("Services assigned successfully.");
                    }

                    this.close_modal("assign_services");
                    this.get_package_services(); // refresh table
                } else {
                    this.show_error("Failed to save assignment: " + (message || "Unknown error"));
                }
            } catch (error) {
                this.show_error("Error assigning services: " + (error.response?.data?.message || error.message));
            }
        },



        async get_services_with_assignment(package_id) {

            const response = await axios.get(SERVICES_IN_PACKAGE, {
                headers: this.headers,
                params: {
                package_id: package_id
                }
            });

            const raw_data = response.data.data || [];

            // Extract actual service IDs
            const assigned_service_ids = raw_data.map(item => item.service?.id);

            // Apply `selected` flag to the services list
            this.table_safe_services_list = this.table_safe_services_list.map(service => ({
                ...service,
                selected: assigned_service_ids.includes(service.id)
            }));

            return assigned_service_ids;
        }






    },

    computed: {

    },

    mounted() {
        this.get_package_services();

    }
};
